import {TypeCustomPropertyPointMarkerSingleVoyage} from "@containers/singleVoyage/containers/points/cluster/types";

export const TYPE_CUSTOM_PROPERTY_POINT_MARKER_SINGLE_VOYAGE:TypeCustomPropertyPointMarkerSingleVoyage = 'point_marker_single_voyage_point'